import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ReachAmyPrimaryLogo from 'app/components/icons/logos/reach-amy';

interface IErrorBoundaryProps {
  readonly children: React.ReactNode;
}

interface IErrorBoundaryState {
  readonly error: any;
  readonly errorInfo: any;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  readonly state: IErrorBoundaryState = { error: undefined, errorInfo: undefined };

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { error, errorInfo } = this.state;
    if (errorInfo) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#f6f5f1',
            gap: 3,
          }}
        >
          <ReachAmyPrimaryLogo sx={{ width: 220, height: 'auto' }} />
          <Typography
            variant="h6"
            sx={{ color: '#292D34', fontFamily: 'Manrope, sans-serif', fontWeight: 500 }}
          >
            Something went wrong
          </Typography>
          <Button
            variant="contained"
            color="primary"
            href="/"
            sx={{ textTransform: 'initial', borderRadius: 2, px: 4 }}
          >
            Go Home
          </Button>
          {DEVELOPMENT && (
            <details style={{ maxWidth: 600, fontSize: 12, color: '#666', whiteSpace: 'pre-wrap' }}>
              {error && error.toString()}
              {errorInfo.componentStack}
            </details>
          )}
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
